<template>
  <div id="app">
    <div>
      <div style="padding: 32px 18px;text-align: left;position: relative;">
        <div class="fc-FFFFFF-fs-la-m" style="color: #202021;text-align: center;margin-top: 44px;">
          <img src="../assets/images/logo.png" style="width: 160px;"/>
        </div>
        <div class="fc-FFFFFF-fs-nor-r" style="color: #999999;font-size: 16px;line-height: 20px;text-align: center;">合同管理系统</div>

        <form class="form-box" style="padding: 16px;margin-top: 24px;padding-right: 0;">
          <div class="cus-row cus-row-v-m">
            <div class="cus-row-col-1 t-al-l"><img src="../assets/images/mobile.png" style="width: 26px;"/></div>
            <div class="cus-row-col-9" style="padding:0 .2rem;box-sizing: border-box">
              <input placeholder="手机号" class="fc-333333-fs-nor-r cus-input" style="border: none;font-size: 18px;" v-model="phone">
            </div>
            <div class="cus-row-col-2 t-al-r" style="box-sizing: border-box;font-size: .5rem !important;">
              <i v-if="phone" style="margin-right: 12px;">
                <van-icon name="clear" @click="phone = ''" :style="{'font-size':'18px','color':'#a0a1a7','vertical-align':'middle'}"/>
              </i>
            </div>
          </div>

          <div style="border-bottom: 1px solid #E5E5E5;margin-left: 18px;margin-top: 16px;margin-bottom: 16px;"></div>

          <div class="cus-row cus-row-v-m">
            <div class="cus-row-col-1 t-al-l"><img src="../assets/images/safety_certificate.png" style="width: 26px;"/></div>
            <div class="cus-row-col-9" style="overflow: hidden;box-sizing: border-box;padding:0 .2rem;">
              <input v-model="password" placeholder="请输入密码" class="fc-333333-fs-nor-r cus-input" style="border: none;font-size: 18px" type="password"/>
            </div>
          </div>
        </form>

        <div style="margin-top: 56px;" class="in-bl-line">
          <a class="bt" style="background-color: rgb(10, 7 ,14) !important;line-height: 48px;font-size: 18px;" href="javascript:void(0);" v-on:click="nextStep">登录</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import common from '../assets/js/common'
import { login } from '../assets/js/api'
import { Toast } from 'vant'

export default {
  data() {
    return {
      phone: '',
      password: '',
    }
  },
  methods: {
    nextStep() {
      if (!this.phone) {
        common.mAlert(this, '请输入用户名')
        return
      }
      if (!this.password) {
        common.mAlert(this, '请输入密码')
        return
      }
      Toast.loading({ duration: 0, mask: true, message: '提交中...' })
      login(this.phone, this.password).then((res) => {
        Toast.clear()
        if (res.errcode === 0) {
          common.setAuth(res.access)
          this.$router.push('/payment')
        } else {
          common.mAlert(this, res.errmsg)
        }
      }).catch(() => {
        Toast.clear()
        common.mAlert(this, '服务异常')
      })
    },
  },
  mounted() {
    this.$store.commit('setTarbarShow', 0)
  },
}
</script>

<style scoped>
.fc-333333-fs-nor-r { background: none !important; }
</style>
<style>
html, body { background: #ffffff !important; }
html { min-height: 100%; }
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.in-bl { display: inline-block; }
.form-box { border-radius: 0.3rem; border: solid 1px #e4e4e4; }
a { text-decoration: none; }
</style>
